import { default as ChevronLeftIcon } from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MailIcon from '@mui/icons-material/Mail';
import { default as MenuIcon } from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import { default as AppBar, default as MuiAppBar } from '@mui/material/AppBar';
import { default as Box } from '@mui/material/Box';
import Button from '@mui/material/Button';
import { default as CssBaseline } from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import { default as Drawer } from '@mui/material/Drawer';
import { default as IconButton } from '@mui/material/IconButton';
import { createUseStyles, useTheme } from 'react-jss';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { default as Toolbar } from '@mui/material/Toolbar';
import { default as Typography } from '@mui/material/Typography';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useResponsive } from './Components/Responsive';
import Content from './Content';
import DrawerContent from './DrawerContent';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import InputAdornment from '@mui/material/InputAdornment';
import { FormGroup, Switch,FormControlLabel } from '@mui/material';
import { Label } from 'react-konva';
import { useAuth0 } from "@auth0/auth0-react";


let theme = createTheme({
  palette: {
    primary: {
      // light: '#63ccff',
      // main: '#009be5',
      // dark: '#006db3',
      light: '#63ccff',
      main: '#F22E17',
      dark: '#006db3',
    },
  },
  typography: {
    h5: {
      fontWeight: 500,
      fontSize: 26,
      letterSpacing: 0.5,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiTab: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
  mixins: {
    toolbar: {
      minHeight: 48,
    },
  },
});

theme = {
  ...theme,
  components: {
    // MuiDrawer: {
    //   styleOverrides: {
    //     paper: {
    //       backgroundColor: '#F22E17',
    //     },
    //   },
    // },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
        contained: {
          boxShadow: 'none',
          '&:active': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          marginLeft: theme.spacing(1),
        },
        indicator: {
          height: 3,
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
          backgroundColor: theme.palette.common.white,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          margin: '0 16px',
          minWidth: 0,
          padding: 0,
          [theme.breakpoints.up('md')]: {
            padding: 0,
            minWidth: 0,
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1),
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: 4,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgb(255,255,255,0.15)',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: '#BE1F0D',
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: 14,
          fontWeight: theme.typography.fontWeightMedium,
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: 'inherit',
          minWidth: 'auto',
          marginRight: theme.spacing(2),
          '& svg': {
            fontSize: 20,
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          width: 32,
          height: 32,
        },
      },
    },
  },
};

const useStyles = createUseStyles({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  btnToolbar: {
    position: 'absolute',
    zIndex: '10',
    marginTop: 5,
    marginRight: 5,
    top: 0,
    right: 0,
  },
  btnDownload: {
    position: 'absolute',
    zIndex: '11',
    marginTop: 5,
    marginLeft: 5,
    top: 0,
    left: 0,
  },

  filterView: {
    position: 'absolute',
    zIndex: '10',
    left: '50%',
    transform: 'translate(-50%, 0)',
    marginTop: 5,
    top: 0,
    padding: '5px'
  },

  // filterViewContent:{
  //     padding: '5px'
  // },

  disabledButton: {
    backgroundColor: 'red'
  },

  mapUtilContainer: {
    border: '0px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

  },
  fetchBales: {
    padding: '10px',
    textAlign: 'center',
    flex: 1,
  },
  selectLayers: {
    padding: '10px',
    textAlign: 'center',
    flex: 1,
  },
  paperMobile: {
    // maxWidth: '800px',
    marginTop: 0,
    width: '100%',
    position: 'absolute',
    "& .MuiDrawer-paper": {
      position: "absolute"
    },
  },

  paperDesktop: {
    maxWidth: '600px',
    marginTop: 20,
    position: 'absolute',
    "& .MuiDrawer-paper": {
      position: "absolute"
    },
  },
  // fab: {
  //     top: 'auto',
  //     right: 20,
  //     bottom: 20,
  //     left: 'auto',
  //     position: 'fixed',
  //     marginRight: 20,
  //     backgroundColor: pink500, // {pink500}
  //     },

  tab: {
    minWidth: '100px', // a number of your choice
    width: '100px', // a number of your choice
  }


});

export default function Paperbase() {

  const boxRef = useRef(null);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  // const responsive = useResponsive()
  // const { isAuthenticated} = useAuth0();

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [open, setOpen] = useState(false)
  const [drawing, setDrawing] = useState({
    sprayers: 1,
    sprayerWidth: 24000,
    tractorWidth: 1850,
    tireWidth: 380,
    bedWidth: 1650,
    ploughFurrow: 3,
    rowPattern: [750, 900, 750, 900],
    rowDistance: 750,
    planterRows: 4,
    rowsPrBed: 2,
    firstRows: 0,
    boomThickness: 400,
    offset: false,
    irrigators: 0,
    irrigationWidth: 72000,
    irrigationAxleWidth: 1850,
    irrigationTireWidth: 380,
    seperationLineWidth: 40,
    numberSize: 300,
    measureLineWidth: 50
  })
  const [rowPattern, setRowPattern] = useState(drawing.rowPattern.map((val) => {
    return val/10
  }))

  const [rowPatternValid, setRowPatternValid] = useState(true)
  const classes = useStyles();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {

    setSize();
  }, [boxRef]);

  const setSize = () => {
    if (boxRef.current) {
      setHeight(boxRef.current.offsetHeight);
      setWidth(boxRef.current.offsetWidth);
      console.log(boxRef.current.offsetWidth)

    }
  }

  useEffect(() => {
    window.addEventListener("resize", setSize);
  }, []);

 
  const [inputValue, setInputValue] = useState(drawing.bedWidth/10);

  const handleBedWidthChange = (e) => {
    const value = e.target.value;
    
    // Only update input value, not the state
    setInputValue(value);

    if (!isNaN(value) && value >= 20) {
      setDrawing({ ...drawing, bedWidth: value * 10 });
    }
  };

  const handleBedWidthBlur = () => {
    // When the input loses focus, validate and update state
    const numValue = parseInt(inputValue);
    
    if (!isNaN(numValue) && numValue >= 20) {
      setDrawing({ ...drawing, bedWidth: numValue * 10 });
    } else {
      // Reset to previous valid value or clear input
      setInputValue(drawing.bedWidth / 10);
    }
  };


  return (
    <Box sx={{ flexGrow: 1, m: '5px', position: 'relative' }} ref={boxRef} >
       {/* <div className={classes.btnDownload}>
          <Button variant="contained" onClick={() => {}}>
             Download
          </Button>
        </div> */}
      {open === false ? (
        <div className={classes.btnToolbar}>
          <Button variant="contained" onClick={() => setOpen(true)}>
            <MenuOpenIcon />
          </Button>
        </div>) : (
        // <Drawer classes={responsive.isMobile === true ? (classes.paperMobile ) : (classes.paperDesktop)} variant={"persistent"} anchor={'right'} open={open} onClose={() => setOpen(false)} BackdropProps={{ invisible: true }}>
        <Drawer sx={{ '& .MuiDrawer-paper': { position: 'absolute' } }} variant={"persistent"} anchor={'right'} open={open} onClose={() => setOpen(false)} BackdropProps={{ invisible: true }}>

          <AppBar position="sticky" color="default">
            <Toolbar>
              <IconButton onClick={() => setOpen(false)}>
                <ChevronRightIcon />
              </IconButton>          
            </Toolbar>
          </AppBar>
          <DrawerContent 
            drawing={drawing} 
            setDrawing={setDrawing} 
          />
        </Drawer>
      )}
     {drawing && <Content width={width} height={height} drawing={drawing}/>}
    </Box>  
  );
}
